import { AnyType } from '@src/models/common';
import { TFilterSchemeOptions } from '../../models';

/** Строим корректный {string} для уже выбранных фильтров */
export const getSelectedOptions = (filter: TFilterSchemeOptions, values?: AnyType[] | null) => {
  const selectedOptions: AnyType[] = [];

  /** Создадим мапу из опций, для получения полных значений опций в values */
  const optionsMap = new Map((filter.options || []).map((o) => [o.id, o]));

  if (values === null || (Array.isArray(values) && values.length === 0)) return selectedOptions;

  Array.isArray(values) &&
    values?.forEach((o) => {
      const fullOption = optionsMap.get(o.id) || o;
      selectedOptions.push(fullOption);
    });

  return selectedOptions;
};
